import { render, staticRenderFns } from "./CandelaDocs.vue?vue&type=template&id=5bc755bc&scoped=true&"
import script from "./CandelaDocs.vue?vue&type=script&lang=js&"
export * from "./CandelaDocs.vue?vue&type=script&lang=js&"
import style0 from "./CandelaDocs.vue?vue&type=style&index=0&id=5bc755bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc755bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu,VTab,VTabs,VToolbar})
